<div class="slideshow-container">
  <div class="mySlides imgWrapper" *ngFor="let url of imageUrls">
    <img src="{{ url }}" />
  </div>
  <!-- Next and previous buttons -->
  <a class="prev" (click)="plusSlides(-1)">&#10094;</a>
  <a class="next" (click)="plusSlides(1)">&#10095;</a>
</div>
<br />
